import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import DirectorySortExample from "./DirectorySortExample";
import { IoSearchSharp } from "react-icons/io5";
import { IoOpenOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";

export default function DirectoryExample() {
  const { t } = useTranslation("marketing");

  const dispatch = useDispatch();
  const { directories } = useSelector((state) => state.landingPage);
  const { sortValue } = useSelector((state) => state.directory);
  const [hoveredItem, setHoveredItem] = React.useState(-1);

  const sortFunction = (a, b) => {
    if (sortValue === "nameZA") {
      return b.name.localeCompare(a.name);
    }
    if (sortValue === "nameAZ") {
      return a.name.localeCompare(b.name);
    }
    if (sortValue === "dateNewestFirst") {
      return new Date(a.dateJoined) - new Date(b.dateJoined);
    }
    if (sortValue === "dateOldestFirst") {
      return new Date(b.dateJoined) - new Date(a.dateJoined);
    }
    return 0;
  };

  return (
    <div className="directory-example-container">
      <div className="directory-example-top">
        <DirectorySortExample />
        <div className="directory-example-top-input-container">
          <input
            type="text"
            className="directory-example-top-input"
            placeholder={t("demo.directorySearch")}
          />
          <button
            className="directory-example-top-button-filter"
            onClick={() => {}}
          >
            <IoSearchSharp />
          </button>
        </div>
      </div>

      <div className="directory-example-items">
        {[...directories].sort(sortFunction).map((family, index) => (
          <div
            key={index}
            className="directory-family-card"
            onMouseEnter={() => setHoveredItem(index)}
            onMouseLeave={() => setHoveredItem(-1)}
            style={{ position: "relative" }}
          >
            <div className="directory-example-family-name">{family.name}</div>
            <div className="family-image">
              {family.image && (
                <img
                  src={family.image}
                  alt={family.name}
                  style={{
                    width: "140px",
                    height: "120px",
                    borderRadius: "10px",
                    objectFit: "cover",
                  }}
                />
              )}
            </div>
            <div
              style={{
                display: `${hoveredItem === index ? "flex" : "none"}`,
                alignItems: "center",
                justifyContent: "center",
                color: "#cccccc",
                fontSize: "16px",
                position: "absolute",
                bottom: "10px",
                right: "10px",
                cursor: "pointer",
                gap: "8px",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <IoOpenOutline style={{ fontSize: "30px" }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
